import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import {
  getRightMenuCardMainAPI,
  postRightMenuCardAPI
} from '../../../services/right-menu'
import { useDispatch } from 'react-redux'
import Error_500 from '../../error/error-500'
import Error_false from '../../error/error-false'
import { ALLMENU, TXTSUCCESS } from '../../../Constants'
import SwalCustom from '../../../alert/swal-custom'
import { FcNext } from 'react-icons/fc'
import { getRighMenuProfiletOrgAPI } from '../../../services/right-org'
import { updateAllMenu } from '../../../actions/allMenu.action'

function CardRight({
  openCard4,
  openSubCard5,
  setOpenSubCard5,
  roleId,
  menuId,
  menuSubid
}) {
  const [reCard, setReCard] = useState([])
  const [card, setCard] = useState([])
  const dispatch = useDispatch()
  const [isSave, setIsSave] = useState(false)

  useEffect(() => {
    setReCard(card)
  }, [card])

  useEffect(() => {
    const getRightMenuCardMain = async () => {
      const param = { roleId, menuId, menuSubId: menuSubid }
      const res = await getRightMenuCardMainAPI(param)
      if (!res) return
      if (res.status) {
        setCard(res.result)
      }
    }
    if (menuSubid) {
      setClickedIndex5(null)
      getRightMenuCardMain()
    }
  }, [menuSubid, isSave])

  const [clickedIndex5, setClickedIndex5] = useState(null)

  const handleClickCard = (c, i) => {
    dispatch({ type: 'SET_CARD_ID', payload: c.card_id })
    setClickedIndex5(i)
    setOpenSubCard5(i === clickedIndex5 ? !openSubCard5 : true)
  }
  const handleCardCheck = (id, check, i) => {
    setCard((prev) => {
      return prev.map((d) => (d.card_id === id ? { ...d, ...check } : d))
    })
  }

  const getRighMenuProfiletOrg = async () => {
    const res = await getRighMenuProfiletOrgAPI()
    if (!res) return
    if (res.status) {
      localStorage.setItem(ALLMENU, JSON.stringify(res.result))
      localStorage.setItem(ALLMENU, JSON.stringify(res.result))
      dispatch(updateAllMenu(res.result))
      // dispatch({ type: 'SET_ALLMENU', payload: res.result ?? allMenus ?? [] });
    }
  }
  const onSubmit = async () => {
    try {
      const selectedCards = card.filter((c) => c.checked)
      setReCard(selectedCards)
      const body = {
        roleId,
        menuId,
        menuSubId: menuSubid,
        cardList: reCard.map((d, i) => {
          return {
            cardId: d.card_id,
            checked: d.checked ? 1 : 0
          }
        })
      }
      SwalCustom({
        title: 'Are you sure?',
        text: 'Do you want to confirm?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!'
      }).then((result) => {
        if (result.isConfirmed) {
          postRightMenuCard(body)
        }
      })
    } catch (error) {
      Error_500(error)
    }
  }

  const postRightMenuCard = async (body) => {
    const resp = await postRightMenuCardAPI(body)
    setIsSave(!isSave)
    if (resp && resp.status) {
      SwalCustom({
        title: 'Success!',
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      })
      getRighMenuProfiletOrg()
    } else {
      Error_false(resp)
    }
  }
  return (
    <span className="col-2">
      {openCard4 ? (
        <>
          <span className="">
            {card.map((c, i) => (
              <div
                className={`pt-2 pb-2 button-box ${
                  clickedIndex5 === i ? 'clicked' : ''
                } `}
                style={{
                  margin: '10px'
                }}
                key={i}
              >
                <span className="d-flex justify-content-between gap-2 m-4 mt-0 mb-0">
                  <Form.Check
                    type="checkbox"
                    checked={c?.checked}
                    onClick={() =>
                      handleCardCheck(
                        c?.card_id,
                        {
                          checked: !c?.checked
                        },
                        i
                      )
                    }
                  />
                  <div
                    className="pointer-event d-flex justify-content-between w-100"
                    onClick={() => handleClickCard(c, i)}
                    style={{
                      minWidth: '120px'
                    }}
                  >
                    <span>{c?.card_name}</span>

                    <span>{c.next ? <FcNext /> : <></>}</span>
                  </div>
                </span>
              </div>
            ))}
          </span>
          <span className="d-flex justify-content-center ">
            <div className="position-absolute bottom-0 ">
              {card[0] ? (
                <Button
                  onClick={onSubmit}
                  style={{ minWidth: '150px', marginBottom: '100px' }}
                >
                  Add
                </Button>
              ) : (
                <></>
              )}
            </div>
          </span>
        </>
      ) : (
        <></>
      )}
    </span>
  )
}

export default CardRight
